import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BotRegistrationService } from 'src/app/services/core/bot-registration/bot-registration.service';
import { NavigationStart, RouterEvent, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-handoff-comment',
  templateUrl: './handoff-comment.component.html',
  styleUrls: ['./handoff-comment.component.scss']
})
export class HandoffCommentComponent implements OnInit {
  _routerSubscription: any;
  handOffCommentInfo : any
  constructor(private dialogRef: MatDialogRef<HandoffCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router){}   

  ngOnInit() {
    this._routerSubscription = this.router.events
     .pipe(
       filter((event: RouterEvent) => event instanceof NavigationStart),
       filter(() => !!this.dialogRef)
     )
     .subscribe(() => {
       this.dialogRef.close();
     });

     this.handOffCommentInfo =  JSON.parse(this.data);
  }
  
  onClose() {
    this.dialogRef.close('Close');
  }
  
}
